module.exports = __webpack_public_path__ + "img/mbe-logo-xl-t.e35ae9c9.png";